import { useQuery } from '@tanstack/react-query';
import { getUsers } from '@services/users.service';

export const USERS_QUERY_KEY = ['users'];

export const useUsers = (params = {}, options = {}) =>
    useQuery({
        queryKey: [...USERS_QUERY_KEY, params],
        queryFn: () => getUsers(params),
        staleTime: 5 * 60 * 1000, // 5 min - avoid refetch when reopening dropdown
        ...options,
    });
